import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import announcementImage from "../assets/image/annoucment.jpg";
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import { useNavigate } from "react-router-dom";

const JoinUsPage = () => {
  let navigate = useNavigate();
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw", 
        margin: 0, 
        padding: 0,
        backgroundImage: `url(${announcementImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat", 
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: "#FFFFFF",
        textAlign: "center",
        position: "fixed", 
        top: 0, 
        left: 0, 
      }}
    >
      {/* Transparent Overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Arka plan karartması
          zIndex: 1,
        }}
      ></Box>

      {/* Content */}
      <Container sx={{ position: "relative", zIndex: 2 }}>
        <Typography variant="h3" fontWeight="bold">
          EKİBİMİZE KATIL
        </Typography>
        <Typography variant="h6" sx={{ mt: 2, mb: 4 }}>
          Doğalında sınır tanımayan, vizyonuyla ezber bozan bir ekibin parçası
          olmak ister misin?
        </Typography>
        <Button
          variant="outlined"
          color="inherit"
          sx={{
            borderColor: "#FFFFFF",
            color: "#FFFFFF",
            padding: "10px 20px",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.2)",
            },
          }}
          onClick={() => {
            navigate("/ilanlar");
          }
          }
        >
          AÇIK POZİSYONLAR
        </Button>
      </Container>

      {/* Scroll Icon */}
      <Box
        sx={{
          position: "absolute",
          bottom: "20px",
          textAlign: "center",
          zIndex: 2,
        }}
      >
        {/* <Typography variant="caption" color="#FFFFFF">
         <ArrowCircleDownIcon sx={{width : "50px",height : "50px"}}/>
        </Typography> */}
      </Box>
    </Box>
  );
};

export default JoinUsPage;
